import { render, staticRenderFns } from "./DuplexZipCable.vue?vue&type=template&id=5e6af81f"
import script from "./DuplexZipCable.vue?vue&type=script&lang=js"
export * from "./DuplexZipCable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports